import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { RouterModule} from '@angular/router';

import { RxLocalizationModule } from '@rxweb/angular-localization'
import { RxReactiveFormsModule } from "@rxweb/reactive-form-validators"
import {  RxRoutingModule} from "@rxweb/angular-router"

import { ForgotPasswordComponent } from './forgot-password.component';
// import { FORGOTPASSWORD_ROUTES } from './forgot-password.routing';
import { CommonModule } from '@angular/common';
import { AuthenticationSharedModule } from '../authentication.shared.module';
import { SharedModule } from '../../shared/shared.module';




@NgModule({
    declarations: [ForgotPasswordComponent],
    imports: [FormsModule, ReactiveFormsModule, RxReactiveFormsModule,
         RxRoutingModule, RxLocalizationModule, CommonModule, AuthenticationSharedModule,SharedModule
    ],
    exports: [RouterModule,ForgotPasswordComponent],
    entryComponents:[ForgotPasswordComponent]
})
export class ForgotPasswordModule { }

